import sectionBannerB1Css from '../css-snippets/section-banner-b1';

const html = `
<style>${sectionBannerB1Css}</style>
<div class="wrapper-container" id="" data-id="" data-attribute="wrapper-container" data-background-color="#ffffff"
  data-enable-background-image="false" data-background="#ffffff" data-top-padding="true" data-bottom-padding="true"
  data-opacity="0" data-text-color="#ffffff"
  style="--text-color: #ffffff; color: rgb(255, 255, 255); background-color: rgb(255, 255, 255); --col-per-view: 3;">
  <div class="background-section"
    data-background-img="https://cdn.skyfastimg.com/images/2025/12/22/image-6948ee5775ee18e0113dd479.jpeg?w=1200&amp;h=50&amp;q=80"
    data-attribute="background-section" data-opacity="1"
    style="opacity: 1; background-image: url(&quot;https://cdn.skyfastimg.com/images/2025/12/22/image-6948ee5775ee18e0113dd479.jpeg?w=1200&amp;h=50&amp;q=80&quot;);">
  </div>
  <div class="background-section-mobile"
    data-background-img="https://cdn.skyfastimg.com/images/2025/12/22/image-6948ee61f35d41073ee73e87.webp?w=500&amp;h=50&amp;q=80"
    data-attribute="background-section-mobile"
    style="opacity: 1; background-image: url(&quot;https://cdn.skyfastimg.com/images/2025/12/22/image-6948ee61f35d41073ee73e87.webp?w=500&amp;h=50&amp;q=80&quot;);"
    data-opacity="1">
  </div>
  <div data-attribute="overlay-bg" class="overlay-bg" data-color="#000000" data-opacity="0.5"
    style="opacity: 0.5; background-color: rgb(0, 0, 0);"></div>
  <div class="container">
    <div class="wrap-content" data-attribute="wrap-content" data-align="left">
      <div class="wrap-text-decor">
        <!-- reting -->
        <div class="block-rating" data-attribute="rating" data-show-rating="true">
          <div class="wrap-rated">
            <div data-attribute="rating-stars" data-value="4" class="wrap-stars">
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
              <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide-icon lucide lucide-star fill-current text-yellow-500">
                <!---->
                <path
                  d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z">
                </path>
                <!----><!----><!---->
              </svg>
            </div>
            <div data-attribute="rating-text" class="wrap-rating" data-text-color="">Trusted by over 10,000 homeowners
            </div>
          </div>
        </div>
        <!-- tag -->
        <div class="tag" data-attribute="tag-name" data-show-tag="true" data-background="#e09f3e"
          style="background-color: rgb(224, 159, 62);" data-text="CYBER WEEK SALE">CYBER WEEK SALE</div>
      </div>
      <!-- title -->
      <div data-attribute="title-banner" data-show-banner-title="true" class="title">
        <h2>Say Goodbye to Cheap Solar Lights That Quit by Dinner</h2>
      </div>
      <!-- content -->
      <div data-attribute="content-banner" data-show-banner-content="true" class="content">
        <p><span style="color:rgb(255,194,120);">Cyber Week Sale:</span> Up to 60% Off + Free Shipping</p>
      </div>
      <!-- button -->
      <div data-attribute="wrap-btn" data-show-btn="true" class="wrap-btn">
        <a data-attribute="button-link" data-background="#aa6d32" data-color="#ffffff" class="btn-slide" href="#"
          style="background-color: #aa6d32; color: #ffffff;">SHOP CYBER WEEK BUNDLES →</a>
        <div data-attribute="sub-button" class="sub-button">🎗️ 100-day money-back guarantee</div>
      </div>
      <!-- features -->
      <div class="features" data-attribute="features" data-show-features="true" data-col-per-view="3">
        <div data-attribute="feature-item">
          <img class="icon" data-attribute="icon-feature"
            src="https://cdn.skyfastimg.com/images/2025/12/22/image-6948edf731b2ca85ba8a491c.png?w=50&amp;h=50&amp;q=80"
            alt="">
          <div data-attribute="text-feature" class="text-feature">100% waterproof &amp; watherproof</div>
        </div>
        <div data-attribute="feature-item">
          <img class="icon" data-attribute="icon-feature"
            src="https://cdn.skyfastimg.com/images/2025/12/22/image-6948ee138ec6a8054c850f79.png?w=50&amp;h=50&amp;q=80"
            alt="">
          <div data-attribute="text-feature" class="text-feature">
            <p>All-night runtime</p>
          </div>
        </div>
        <div data-attribute="feature-item">
          <img class="icon" data-attribute="icon-feature"
            src="https://cdn.skyfastimg.com/images/2025/12/22/image-6948ee1ed07d8353b09d1777.png?w=50&amp;h=50&amp;q=80"
            alt="">
          <div data-attribute="text-feature" class="text-feature">
            <p>No setup&nbsp;<br>required</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;
export default html;
